export default __webpack_public_path__ + "static/media/5 Self Assessments.981f3c8d.webp";